import { Button } from '@bridebook/aura';
import { MailPlus, Check } from '@bridebook/aura/src/icons';
import { useTranslation } from 'next-i18next';

interface MainGuestEmailButtonProps {
  isUsingHeadGuestEmail: boolean;
  onUseEmail: () => void;
  className?: string;
}

export const MainGuestEmailButton = ({
  isUsingHeadGuestEmail,
  onUseEmail,
  className,
}: MainGuestEmailButtonProps) => {
  const { t } = useTranslation('guestlist');

  return (
    <Button
      variant="ghost"
      size="sm"
      icon={isUsingHeadGuestEmail ? Check : MailPlus}
      type="button"
      className={className}
      disabled={isUsingHeadGuestEmail}
      onClick={onUseEmail}>
      {isUsingHeadGuestEmail
        ? t('mainGuestEmailButton.usingMainGuestEmail')
        : t('mainGuestEmailButton.useMainGuestEmail')}
    </Button>
  );
};
